import { Form } from 'react-bootstrap'
import React from 'react'
import { useTranslation } from 'react-i18next'
import MandatoryField from '../../MandatoryField/MandatoryField'


const StatisticForSingleRFID = ({ formData, setFormData, formErrors }) => {
    const { t } = useTranslation()
    return (
        <div>
            <Form.Group className="mb-3">
                <Form.Label>{`${t('inventory:scanCode')} *`}</Form.Label>
                <Form.Control
                    name="rfid"
                    onChange={e => setFormData(prev => ({
                        ...prev,
                        rfid: e.target.value
                    }))}
                    value={formData.rfid || ''}
                    isInvalid={formErrors && formErrors.rfid}
                    />
                <Form.Control.Feedback type="invalid">
                    {formErrors && formErrors.rfid}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t(`reportConfig:emailAddress`)}</Form.Label>
                <Form.Control
                    name="emailAddress"
                    onChange={e => setFormData(prev => ({
                        ...prev,
                        emailAddress: e.target.value
                    }))}
                    value={formData.emailAddress || ''}
                    isInvalid={formErrors && formErrors.emailAddress}
                    autoComplete="email" />
                <Form.Control.Feedback type="invalid">
                    {formErrors && formErrors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>
            <MandatoryField />
        </div>
    )
}
export default StatisticForSingleRFID